import { requestHandler } from "../lib/utils/network-client";

export function getNmcProformas(params = {}) {
  return requestHandler("/nmc-prescribed-proforma", {
    params
  });
}

export function createNmcProforma(payload) {
  return requestHandler("/nmc-prescribed-proforma", {
    method: "POST",
    body: payload
  });
}

export function updateNmcProforma(id, payload) {
  return requestHandler(`/nmc-prescribed-proforma/${id}`, {
    method: "PUT",
    body: payload
  });
}

export function deleteNmcProforma(id) {
  return requestHandler(`/nmc-prescribed-proforma/${id}`, {
    method: "DELETE"
  });
}
